const state = {
  isFullscreen: false,
  hasHeader: true
};

const getters = {
  getIsFullscreen: () => state.isFullscreen,

  getHasHeader: () => state.hasHeader
};

const actions = {};

const mutations = {
  setIsFullscreen(state, payload) {
    state.isFullscreen = payload;
  },
  toggleIsFullscreen(state) {
    state.isFullscreen = !state.isFullscreen;
  },
  setHasHeader(state, boolean) {
    state.hasHeader = boolean;
  },
  toggleHasHeader(state) {
    state.hasHeader = !state.hasHeader;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
